import React, { VFC } from 'react';
import { useIntl } from 'react-intl';

import { HStack, Text, VStack } from '@fhs-legacy/universal-components';
import Currency from 'components/currency';
import { usePaymentContext } from 'state/payment';
import { IPaymentMethod } from 'state/payment/types';
import { theme } from 'styles/configure-theme';
import { CARD_ALIAS_TRANSLATION_ID } from 'utils/gift-card/constants';

import { MethodType } from './styled';

interface IPrepaidMethodBalance {
  method: IPaymentMethod;
  isDisabled: boolean;
  fullWidthDescription?: boolean;
}

const PrepaidMethodBalance: VFC<IPrepaidMethodBalance> = ({
  method,
  isDisabled,
  fullWidthDescription = true,
}) => {
  const { getBalanceFromPaymentMethods, hasGetPaymentMethodsError } = usePaymentContext();
  const { formatMessage } = useIntl();
  const errorMessage = formatMessage({ id: 'balanceLoadingError' });

  const renderMethodType = () => (
    <MethodType color={isDisabled ? theme.token('text-disabled') : theme.token('text-default')}>
      {formatMessage(
        { id: 'payWithMyPrepaidCard' },
        { cardAlias: formatMessage({ id: CARD_ALIAS_TRANSLATION_ID }) }
      )}
      {fullWidthDescription && ' - '}
    </MethodType>
  );

  if (hasGetPaymentMethodsError) {
    if (fullWidthDescription) {
      return (
        <HStack alignItems="center">
          {renderMethodType()}
          <Text color={theme.token('text-error')} margin={0}>
            ---
          </Text>
          <Text color={theme.token('text-error')} marginLeft={1} fontSize="xs">
            {errorMessage}
          </Text>
        </HStack>
      );
    }

    return (
      <VStack>
        <HStack alignItems="center">{renderMethodType()}</HStack>
        <HStack alignItems="center">
          <Text color={theme.token('text-error')} margin={0} fontSize="xs">
            ---
          </Text>
          <Text color={theme.token('text-error')} marginLeft={1} fontSize="xs">
            {errorMessage}
          </Text>
        </HStack>
      </VStack>
    );
  }

  if (fullWidthDescription) {
    return (
      <HStack alignItems="center">
        {renderMethodType()}
        <Currency
          amount={getBalanceFromPaymentMethods(method)}
          textProps={{
            margin: 0,
          }}
        />
      </HStack>
    );
  }

  return (
    <VStack>
      <HStack alignItems="center">{renderMethodType()}</HStack>
      <HStack alignItems="center">
        <Currency
          amount={getBalanceFromPaymentMethods(method)}
          textProps={{
            margin: 0,
            fontSize: 'xs',
          }}
        />
      </HStack>
    </VStack>
  );
};

export default PrepaidMethodBalance;
